export const initialiseUserway = () => {
  const userWay = document.createElement('script')

  userWay.setAttribute('data-language', navigator.language.split('-')[0])
  userWay.setAttribute('data-color', '#197B78')
  userWay.setAttribute('data-account', 'pxpOtbe7IY')
  userWay.setAttribute('src', 'https://cdn.userway.org/widget.js')
  ;(document.body || document.head).appendChild(userWay)
}
